import React from 'react';
import { Prompt, Model, PromptFunction } from '../../../../Types';
import TabSection from './TabSection';
import TabHeadline from './TabHeadline';
import InfoButton from '../../../Utility/InfoButton';
import ConnectorItem from './ConnectorItem';
import { PaginationWrapper } from '../../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { connectorService } from '../../../../Services/connectorService';
import useSearchFilter from '../../../../Hooks/useSearchFilter';
import SearchFilter from '../../../Utility/SearchFilter';

interface ConnectorTabProps {
    prompt: Prompt;
    userPrompt: boolean;
    i18n: any;
    handlePromptFunctionCheckboxChange: any;
    PromptActions: any;
}

function ConnectorTab({ prompt, userPrompt, i18n, handlePromptFunctionCheckboxChange }: ConnectorTabProps) {
    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });

    return (
        <div className="w-full">
            <TabHeadline
                title={i18n.translate({
                    id: 'tabs.connectors.title',
                    sourceName: 'Prompt',
                })}
            />
            <InfoButton configKey="connector" />

            <TabSection
                title={i18n.translate({
                    id: 'tabs.connectors.section.connectors.title',
                    sourceName: 'Prompt',
                })}
                subline={i18n.translate({
                    id: 'tabs.connectors.section.connectors.subtitle',
                    sourceName: 'Prompt',
                })}
            >
                <SearchFilter
                    value={localQuery}
                    onChange={searchActions.setLocalQuery}
                    onApply={searchActions.applyQuery}
                    onClear={searchActions.clearQuery}
                    className="mb-6"
                />

                <PaginationWrapper
                    listType={PaginationListType.Connectors}
                    itemsFunction={
                        !userPrompt
                            ? connectorService.getPromptFunctionsByPage
                            : connectorService.getUserPromptFunctionsByPage
                    }
                    itemsPerPage={12}
                    query={query ?? null}
                    renderItem={(promptFunction: PromptFunction, index: number) => (
                        <ConnectorItem
                            key={promptFunction.identifier}
                            title={promptFunction.title ?? ''}
                            image={promptFunction.image}
                            identifier={promptFunction.identifier}
                            handleChangeFunction={() => {
                                handlePromptFunctionCheckboxChange({
                                    target: {
                                        checked: !prompt.functions.includes(promptFunction.identifier),
                                        name: promptFunction.identifier,
                                    },
                                } as React.ChangeEvent<HTMLInputElement>);
                            }}
                            isActive={prompt.functions.includes(promptFunction.identifier)}
                        />
                    )}
                    className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-3 2xl:grid-cols-3 gap-3"
                />
            </TabSection>
        </div>
    );
}

export default ConnectorTab;
